import { useEffect } from 'react';

const PRODUCT_NAME = 'Lehti AI';

/**
 * The browser tab names the page and the forest it is about —
 * "<page> · <property>" — so several open forests stay distinguishable.
 * Outside a property context the product name stands in for the property.
 */
export function shellDocumentTitle(page: string | null, property: string | null): string {
  if (!page) return PRODUCT_NAME;
  return `${page} · ${property ?? PRODUCT_NAME}`;
}

export function useShellDocumentTitle(page: string | null, property: string | null): void {
  useEffect(() => {
    document.title = shellDocumentTitle(page, property);
    return () => {
      document.title = PRODUCT_NAME;
    };
  }, [page, property]);
}
